import { useSelector } from 'react-redux'
import UserAvailabilitiesTable from '../userAvailability/UserAvailabilitiesTable';
import adminLogo from '../../Images/admin_img.jpg'

const UserAvailabilities = () => {
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);

  return (
    <>
      <div
        className='table-container'
        style={{
          paddingBottom: '2rem',
          backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '90vh',
          position: 'relative' // Needed for overlay positioning
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backdropFilter: 'blur(5px)', // Blur effect
            WebkitBackdropFilter: 'blur(5px)', // Safari support
            backgroundColor: 'rgba(0, 0, 0, 0.82)', // Optional dark shade
            zIndex: 0 // Below content
          }}
        />
        <UserAvailabilitiesTable />
      </div>
    </>
  );
}
export default UserAvailabilities;

